import React from 'react';

import { connect } from 'react-redux';
import { Formik, Field } from 'formik';

import SelectField from '../../components/SelectField';
import ScreenWrapper from '../../components/ScreenWrapper';
import DatePickerField from '../../components/DatePickerField';

import { PAGES } from '../../config/constants';
import { yes_no } from '../../constants/yes_no';
import pms_exit_strategy from '../../constants/pms_exit_strategy';
import pms_exit_repay_loan from '../../constants/pms_exit_repay_loan';
import pms_suburban_or_rural from '../../constants/pms_suburban_or_rural';
import pms_occupancy_at_closing from '../../constants/pms_occupancy_at_closing';

import validations from './validations3';

const ConsoleBrok3 = ({ setPrevPage, setValues, consoleBrok1 }) => {
  const initialValues = {
    occupancy_at_closing: consoleBrok1.occupancy_at_closing,
    suburban_or_rural: consoleBrok1.suburban_or_rural,
    coe_date: consoleBrok1.coe_date,
    exit_strategy: consoleBrok1.exit_strategy,
    exit_repay_loan: consoleBrok1.exit_repay_loan,
  };

  return (
    <ScreenWrapper>
      <Formik
        initialValues={initialValues}
        onSubmit={values => {
          setValues(values);
        }}
        validate={validations}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            <Field
              name="occupancy_at_closing"
              component={SelectField}
              label="Occupancy at COE *"
              options={pms_occupancy_at_closing}
              required
            />

            <Field
              name="suburban_or_rural"
              component={SelectField}
              label="Suburban / Rural *"
              options={pms_suburban_or_rural}
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="impounds"
              component={SelectField}
              label="Impounds *"
              options={yes_no}
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="coe_date"
              component={DatePickerField}
              label="Preferred Close Date  (PCD) *"
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="exit_strategy"
              component={SelectField}
              label="Exit Strategy *"
              options={pms_exit_strategy}
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="exit_repay_loan"
              component={SelectField}
              label="How do you Plan to exit Loan *"
              options={pms_exit_repay_loan}
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <div className="container-fluid">
              <div style={{ marginTop: 10 }}>
                <div style={{ float: 'left' }}>
                  <button type="button" className="cstm_btn cstm_btn-green" onClick={setPrevPage}>
                    Back
                  </button>
                </div>
                <div style={{ float: 'right' }}>
                  <button type="button" className="cstm_btn cstm_btn-green" onClick={handleSubmit}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Formik>
    </ScreenWrapper>
  );
};

const mapState = state => {
  return {
    consoleBrok1: state.consoleBrok1,
  };
};

const mapDispatch = dispatch => {
  return {
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.CONSOLE_BROOK_2,
      });
    },

    setValues: values => {
      dispatch({
        type: 'SET_CONSOLE_BROK1',
        payload: values,
      });

      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.CONSOLE_BROOK_4,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(ConsoleBrok3);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/ConsoleBrok3.js